<div class="grab-bonus-badge" [style.width.px]="width">
  <img
    class="grab-bonus-badge-image"
    src="https://s3.eu-west-2.amazonaws.com/bucket.engineius.portal-static-content/juno/grab-bonus_inc_robot.png"
    alt="Grab Bonus"
  />
  <span class="grab-bonus-badge-count" [style.font-size.px]="countFontSize">+{{ count }}</span>
</div>
